import script from "./productType.vue?vue&type=script&setup=true&lang=js"
export * from "./productType.vue?vue&type=script&setup=true&lang=js"

import "./productType.vue?vue&type=style&index=0&id=4c80fd10&lang=less"

const __exports__ = script;

export default __exports__